import type { GetSubscriptionStatusLabelParams, SubscriptionStatus } from '../types';

const STATUS_LABELS: Record<SubscriptionStatus, string> = {
    active: 'Active',
    trialing: 'Trialing',
    past_due: 'Past due',
    canceled: 'Canceled',
    unpaid: 'Unpaid',
    incomplete: 'Incomplete',
    incomplete_expired: 'Incomplete expired',
    paused: 'Paused',
    none: 'No subscription',
};

const getSubscriptionStatusLabel = ({ status }: GetSubscriptionStatusLabelParams): string =>
    STATUS_LABELS[status];

export default getSubscriptionStatusLabel;
